var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          maxWidth: _vm.getMaxWidth,
          minWidth: _vm.getMinWidth,
          minHeight: "85vh"
        },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_preview,
        callback: function($$v) {
          _vm.show_preview = $$v
        },
        expression: "show_preview"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_preview = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n\t\t\t\t" + _vm._s(_vm.$t(_vm.game_name)) + "\n\t\t\t"
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c("div", { staticClass: "q-pa-xs" }, [
              _c("p", { staticClass: "text-bold" }, [
                _vm._v(_vm._s(_vm.$t("game_preview")))
              ]),
              !_vm.game_finished
                ? _c(
                    "div",
                    [
                      _c(
                        "q-carousel",
                        {
                          staticClass: "q-my-sm",
                          attrs: {
                            color: "primary",
                            easing: _vm.overshoot,
                            autoplay: _vm.autoplay,
                            height: "550px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "control-progress",
                                fn: function(carousel) {
                                  return _c(
                                    "q-carousel-control",
                                    {
                                      attrs: {
                                        position: "top",
                                        offset: [260, 10]
                                      }
                                    },
                                    [
                                      _c("q-progress", {
                                        attrs: {
                                          percentage: carousel.percentage,
                                          stripe: "",
                                          color: "primary",
                                          animate: _vm.autoplay
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            193504830
                          ),
                          model: {
                            value: _vm.slide,
                            callback: function($$v) {
                              _vm.slide = $$v
                            },
                            expression: "slide"
                          }
                        },
                        [
                          _vm._l(_vm.cards, function(card, index) {
                            return _c(
                              "q-carousel-slide",
                              {
                                key: index,
                                staticClass:
                                  "flex flex-center q-mb-lg bg-gray-1"
                              },
                              [
                                _c(
                                  "q-card",
                                  { staticClass: "card-style" },
                                  [
                                    _c("q-card-main", [
                                      _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "q-headline" },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.slide +
                                                      1 +
                                                      "/" +
                                                      _vm.number_of_cards
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "image-container q-mt-sm"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row justify-center foreground q-ml-md",
                                                  class:
                                                    card.correct === true
                                                      ? "correct"
                                                      : card.correct === false
                                                      ? "incorrect"
                                                      : ""
                                                },
                                                [
                                                  card.correct === false
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row items-end"
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "q-headline tip"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "tip"
                                                                    ) +
                                                                      ": " +
                                                                      card.tip +
                                                                      "..."
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c(
                                                "q-card-media",
                                                { staticClass: "q-ml-md" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src:
                                                        card.image_link_signed
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "q-body-2 q-my-sm" },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(card.description) +
                                                  "\n\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "row q-my-sm q-ml-md"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "offset-1 col-8"
                                                },
                                                [
                                                  _c(
                                                    "q-field",
                                                    [
                                                      _c("q-input", {
                                                        attrs: {
                                                          readonly:
                                                            card.correct !==
                                                            null,
                                                          "float-label": _vm.$t(
                                                            "answer"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            card.user_answer,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              card,
                                                              "user_answer",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "card.user_answer"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "col-2" },
                                                [
                                                  card.correct === null
                                                    ? _c("q-btn", {
                                                        staticClass:
                                                          "q-pa-md q-mt-sm q-ml-sm",
                                                        attrs: {
                                                          dense: "",
                                                          color: "amber",
                                                          disable: !card
                                                            .user_answer.length,
                                                          icon:
                                                            "fal fa-paper-plane"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.sendAnswer(
                                                              index
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _c("q-btn", {
                                                        staticClass:
                                                          "q-pa-xs q-mt-sm",
                                                        attrs: {
                                                          dense: "",
                                                          color: card.correct
                                                            ? "positive"
                                                            : "negative",
                                                          label: card.correct
                                                            ? _vm.$t("correct")
                                                            : _vm.$t(
                                                                "incorrect"
                                                              ),
                                                          icon: card.correct
                                                            ? "fal fa-thumbs-up"
                                                            : "fal fa-thumbs-down"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            !card.correct
                                                              ? _vm.tryCardAgain(
                                                                  index
                                                                )
                                                              : null
                                                          }
                                                        }
                                                      })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _c(
                            "q-carousel-control",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.slide > 0,
                                  expression: "slide > 0"
                                }
                              ],
                              staticClass: "text-white",
                              staticStyle: {
                                background: "rgba(0, 0, 0, .3)",
                                padding: "4px",
                                "border-radius": "4px"
                              },
                              attrs: {
                                slot: "control",
                                position: "bottom-left",
                                offset: [150, 160]
                              },
                              slot: "control"
                            },
                            [
                              _c("q-btn", {
                                attrs: {
                                  flat: "",
                                  color: "primary",
                                  icon: "fas fa-arrow-left",
                                  disable: _vm.slide >= _vm.number_of_cards
                                },
                                on: {
                                  click: function($event) {
                                    _vm.slide -= 1
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-carousel-control",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.slide < _vm.number_of_cards - 1,
                                  expression: "slide < number_of_cards - 1"
                                }
                              ],
                              staticClass: "text-white",
                              staticStyle: {
                                background: "rgba(0, 0, 0, .3)",
                                padding: "4px",
                                "border-radius": "4px"
                              },
                              attrs: {
                                slot: "control",
                                position: "bottom-right",
                                offset: [150, 160]
                              },
                              slot: "control"
                            },
                            [
                              _c("q-btn", {
                                attrs: {
                                  flat: "",
                                  color: "primary",
                                  icon: "fas fa-arrow-right",
                                  disable: _vm.slide >= _vm.cards.length
                                },
                                on: {
                                  click: function($event) {
                                    _vm.slide += 1
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.game_finished
                ? _c(
                    "div",
                    { staticClass: "col-10 q-mt-lg" },
                    [
                      _c("p", { staticClass: "text-bold q-mt-sm" }, [
                        _vm._v(_vm._s(_vm.$t("result")))
                      ]),
                      _c("q-slider", {
                        attrs: {
                          disable: "",
                          markers: "",
                          snap: "",
                          color: _vm.game_finished
                            ? _vm.getSliderColor()
                            : "blue-6",
                          min: 0,
                          max: _vm.number_of_cards
                        },
                        model: {
                          value: _vm.user_score,
                          callback: function($$v) {
                            _vm.user_score = $$v
                          },
                          expression: "user_score"
                        }
                      }),
                      _c("p", { staticClass: "q-mt-sm" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t("correct_answers") +
                                ": " +
                                _vm.user_score +
                                " / " +
                                _vm.number_of_cards
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ]),
                      _vm.user_won
                        ? _c("p", [_vm._v(_vm._s(_vm.$t(_vm.success_message)))])
                        : _c("p", [_vm._v(_vm._s(_vm.$t(_vm.failure_message)))])
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "col-xs-12 q-mt-md" }, [
              _c(
                "div",
                { staticClass: "row justify-end" },
                [
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("back") },
                    on: { click: _vm.resetGame }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }